import { Checkbox, Flex } from 'components';
import React from 'react';

import { FlexParent, LongAndTruncated, ShortAndFixed, TableRowActions, TableTd, TableTh, TableTr } from '../styles';
import { TableRowProps } from '../types';
import useTable from '../useTable';

function TableRow<ObjectType>({ object, properties, selected, selectRowKey, hideCheckbox }: TableRowProps<ObjectType>) {
  const { handleSelectRow } = useTable();

  return (
    <TableTr data-selected={selected}>
      {properties.map((property, propertyIndex) => {
        return !propertyIndex ? (
          <TableTh
            key={`table-row-${propertyIndex.toString()}-${String(property.key)}-${String(object[selectRowKey])}`}
            style={{ width: property.options?.width || 300, ...property.options?.rowstyle }}
          >
            <FlexParent style={{ width: property.options?.width || 300 }}>
              {!!property.hoverActions?.length && (
                <TableRowActions data-actions={!!property?.actions?.length}>
                  {property.hoverActions.map((action) => action(object[property.key], object))}
                </TableRowActions>
              )}

              {!hideCheckbox && (
                <Flex flexGrow={0} ml="12px">
                  <Checkbox
                    id={`row-${selectRowKey.toString()}-${object[selectRowKey]}`}
                    name={`row-${selectRowKey.toString()}`}
                    value={String(object[selectRowKey])}
                    onChange={handleSelectRow}
                    checked={selected}
                    color="gray_600"
                  />
                </Flex>
              )}

              <LongAndTruncated type="type3" ml={12}>
                <label htmlFor={`row-${selectRowKey.toString()}-${object[selectRowKey]}`}>
                  {property.render ? property.render(object[property.key], object) : object[property.key]}
                </label>
              </LongAndTruncated>

              <ShortAndFixed>{!!property.actions?.length && property.actions.map((action) => action(object[property.key], object))}</ShortAndFixed>
            </FlexParent>
          </TableTh>
        ) : (
          <TableTd
            key={`table-row-${propertyIndex.toString()}-${String(property.key)}-${String(object[selectRowKey])}`}
            style={{
              width: property.options?.width || 'inherit',
              ...property.options?.rowstyle,
            }}
          >
            <div style={property.options?.style ? property.options?.style : {}}>
              {property.render ? property.render(object[property.key], object) : object[property.key]}
            </div>
          </TableTd>
        );
      })}
    </TableTr>
  );
}

export default React.memo(TableRow) as typeof TableRow;
